import { connect } from 'react-redux';
import ApproveConsentAfterRequest from './ApproveConsentAfterRequest';
import { getTranslation } from "../../../reducers/common/localization";
import {
    fetchGetConsentById, getFormattedConsent, loadingConsent,
    fetchUpdateConsent
} from "../../../reducers/consent/consent";
import {getCurrentConsentId, loadingConsents, onSetNextConsent} from "../../../reducers/consent/consents";

const mapStateToProps = (state) => {
    return {
        id: getCurrentConsentId(state),
        data: getFormattedConsent(state),
        translation: getTranslation(state),
        loading: loadingConsent(state) || loadingConsents(state)
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        onLoadConsent: (id) => {
            dispatch(fetchGetConsentById(id));
        },
        onGrantRequest: (id, data) => {
            dispatch(fetchUpdateConsent(id, data));
        },
        onRefuseRequest: (id, data) => {
            dispatch(fetchUpdateConsent(id, data));
        },
        onNext: () => dispatch(onSetNextConsent())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ApproveConsentAfterRequest);



// WEBPACK FOOTER //
// ./src/components/consentManagement/approveConsentAfterRequest/ApproveConsentAfterRequest.container.js